export const COOKIE_ID_TOKEN = "id_token";
export const DISCOUNTED_CAMPAIGN_BREAKFAST_CODE = "108";
export const PRIVATE_ROUTES = ["/get-booking", "/my/"];

/* Contentful entries */
export const CONTENTFUL_FOOTER_ID = "qbjrujxO6wKCBNt9wPDuD";
export const CONTENTFUL_NAVIGATION_ID = "BDioMqnQSecK7IPMswtk7";
export const BLOG_LANDING_PAGE_ID = "3SJTcdOjGHpBqXuLiCj70B";
export const LEGAL_LANDING_PAGE_ID = "33RUd173JlxG2ZGd1C3Zrp";
export const HOTEL_LANDING_PAGE_ID = "2DtOFXyUaWr6vYhO6W7yqo";

/* Booking Flow / Rates */
export const RATE_PLAN_CATEGORIES = { CAMPAIGN: "campaign" };
export const RATES_LIMITED_MAX_ROOMS_CATEGORIES = [
  "mycitizenmplus",
  "campaign",
];
export const RATES_INPUT_DATE_FORMAT = "y-LL-dd";
export const RATES_DISPLAY_DATE_FORMAT = "d LLL";

/* Tracking */
export const TRACKING_DATE_FORMAT = "yyyy-MM-dd";
